import { render, staticRenderFns } from "./PanelConfig.vue?vue&type=template&id=0bff04c6&"
import script from "./PanelConfig.vue?vue&type=script&lang=ts&"
export * from "./PanelConfig.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports